import LogsService from "../../service/LogsService";
//import swal from 'sweetalert'

export const namespaced = true

export const state = {
    logsLoading: true,
    ftLogs: [],
    neLogs: [],
    ftLoading: true,
    neLoading: true,
    balanceLoading: true,
    ftMetrics: {
        type:'last30',
        startDate:null,
        endDate:null,
    },
    balance:{
        responsedatetime:'',
        responsecode:'',
        accountnumber:'',
        accountname:'',
        balance:null,
        responsemessage:'',
        ccy:'',
        accounttype:''
    },
    neMetrics: {
        type:'last30',
        startDate:null,
        endDate:null,
    },
    response: {}
}


export const getters = {
    neLogs: state => {
        return state.neLogs
    },
    ftLogs: state => {
        return state.ftLogs
    }
}


export const mutations = {
    updateFtLogs: (state, payload) =>{
        state.ftLogs = payload
    },
    updateFtLogsPush: (state, payload) =>{
        state.ftLogs = state.ftLogs.concat(payload)
        // payload.forEach(function (log) {
        //     state.ftLogs.push(log)
        // })
    },
    updateNeLogs: (state, payload) =>{
        state.neLogs = payload
    },
    updateNeMetrics: (state, payload) =>{
        state.neMetrics = payload
    },
    updateFtMetrics: (state, payload) =>{
        console.log("updateFtMetrics: ",payload)
        state.ftMetrics = payload
    },
    updateResponse: (state, payload) =>{
        state.response = payload
    },
    updateBalance: (state, payload) =>{
        state.balance = payload
    },
    updateLogsLoading: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.logsLoading = payload;
    },
    reset: (state, payload) =>{
        state.logsLoading = payload;
        state.ftLogs = {};
        state.neLogs = {};
        state.response = {};
    },
    updateFtLoading: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.ftLoading = payload;
    },
    updateNeLoading: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.neLoading = payload;
    },
    updateBalanceLoading: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.balanceLoading = payload;
    },
}


export const actions = {
    readFtLogs: ({ commit, state }, payload)=>{
        if(state.ftLogs.length < 1)
            commit("updateFtLoading", true);
        payload.startDate = state.ftMetrics.startDate;
        payload.endDate = state.ftMetrics.endDate;
        return LogsService.callFtLogApi(payload)
            .then(response => {
                if (response.data.responsecode === "00") {
                    console.log(response.data.responsecode)
                    commit("updateResponse", response.data.ftLogs)
                    commit("updateFtLogs", response.data.ftLogs)
                    // if (response.data.page === 1)
                    //     commit("updateFtLogs", response.data.ftLogs)
                    // else
                    //     commit("updateFtLogsPush", response.data.ftLogs)
                    // let noOfRowsLeft = response.data.rows - ((response.data.page-1)*response.data.divider)
                    // console.log("noOfRowsLeft: ",noOfRowsLeft)
                    // if ((noOfRowsLeft/response.data.divider) > 1){
                    //     payload.page = response.data.page+1
                    //     dispatch("logs/readFtLogs", payload, {root: true});
                    // }else{
                    //     commit("updateFtLoading", false)
                    // }
                    commit("updateFtLoading", false)
                }else{
                    commit("updateFtLoading", false)
                    commit("updateFtLogs", [])
                }

            })
            .catch(error => {
                commit("updateFtLoading", false)
                alert(error)
                // throw error;
            });
    },
    balanceEnquiry: ({ commit, state }, payload)=>{
        // console.log("updateDocuments>>>>>>"+state.ftLogs.length)
        if(state.ftLogs.length < 1)
            commit("updateBalanceLoading", true);
        // payload.startDate = state.ftMetrics.startDate;
        // payload.endDate = state.ftMetrics.endDate;
        return LogsService.callBalanceEnquiryApi(payload)
            .then(response => {
                commit("updateBalanceLoading", false);
                if (response.data.responsecode === "00") {
                    commit("updateBalance", response.data)
                }else{
                    commit("updateBalance", {})
                }

            })
            .catch(error => {
                commit("updateBalanceLoading", false);
                alert(error)
                // throw error;
            });
    },
    readNeLogs: ({ commit }, payload)=>{
        // console.log("updateDocuments>>>>>>")
        if(state.neLogs.length < 1)
            commit("updateNeLoading", true);
        payload.startDate = state.neMetrics.startDate;
        payload.endDate = state.neMetrics.endDate;
        return LogsService.callNameEnquiryLogApi(payload)
            .then(response => {
                commit("updateNeLoading", false)
                if (response.data.responsecode === "00") {
                    commit("updateNeLogs", response.data.nameenquiries)
                }else{
                    commit("updateNeLogs", [])
                }

            })
            .catch(error => {
                commit("updateNeLoading", false)
                alert(error)
                // throw error;
            });
    },
    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }
}
